import { useTranslation } from "react-i18next";
import {
  convertNumberFormat,
  getEdgeClass,
  scrollToBottomFunction,
} from "../../utils";
import SuperscriptScrollToBottom from "../common-components/SuperscriptScrollToBottom";
import { useSelector } from "react-redux";
import OrderVehicleFromBMWButton from "../OrderVehicleFromBMWButton";
import SealOfQualityBadge from "../SealOfQualityBadge";
import PreviousUsageTypeBadge from "../PreviousUsageTypeBadge";

const BuyingTabView = ({ vehicleDetails, priceDetails, currency }) => {
  const { t } = useTranslation();
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};

  const isOrderVehicleFromBMWAG =
    vehicleDetails?.previousUsageType?.id === 18 ||
    vehicleDetails?.isAgencySales === true;

  return (
    <ul className="space-y-1 pe-2">
      {priceDetails?.netPrice ||
      priceDetails?.totalPrice ||
      priceDetails?.oldListPrice?.totalPrice ? (
        <li className="flex max-sm:block">
          <div className="flex gap-2 items-baseline flex-wrap my-2 flex-col">
            {(vehicleDetails?.previousUsageType?.name ||
              vehicleDetails?.sealOfQualityLabel !== "None") && (
              <div
                className="px-4 w-full grid grid-cols-1 gap-2"
                style={{ maxWidth: "max-content" }}
              >
                {isOrderVehicleFromBMWAG && (
                  <OrderVehicleFromBMWButton
                    isOrderVehicleFromBMWAG={isOrderVehicleFromBMWAG}
                    btnTitle={t("/vehicles.Order vehicle from BMW AG")}
                    btnClass={"text-[0.75rem]"}
                  />
                )}
                <PreviousUsageTypeBadge
                  previousUsageType={vehicleDetails?.previousUsageType}
                  fullWidth
                />
                <SealOfQualityBadge
                  sealOfQualityLabel={vehicleDetails?.sealOfQualityLabel}
                  fullWidth
                />
                <span>
                  {vehicleDetails?.availableFrom &&
                  vehicleDetails?.availableFrom?.date &&
                  vehicleDetails?.availableFrom?.dateString &&
                  new Date(vehicleDetails?.availableFrom?.date) > new Date() ? (
                    <span
                      className={`${getEdgeClass(edge, "rounded-2xl")} flex items-center justify-center text-[0.75rem] text-[#999898] pb-[3px] h-auto whitespace-nowrap`}
                    >
                      {t("/vehicles.AvailableFrom")}{" "}
                      {vehicleDetails?.availableFrom?.dateString}
                    </span>
                  ) : null}
                </span>
              </div>
            )}
          </div>
          <div className="flex items-end flex-col max-sm:block flex-[1.5]">
            {priceDetails?.totalPrice ? (
              <h4 className="text-xl font-end text-[var(--text-black-white)] max-md:text-lg">
                <span className="text-4xl">
                  {convertNumberFormat(priceDetails?.totalPrice, currency)}
                  {priceDetails?.vatDeductible ? (
                    <SuperscriptScrollToBottom
                      title={"i"}
                      onClick={() =>
                        scrollToBottomFunction("suggested-container")
                      }
                      className="top-[-1em]"
                    />
                  ) : null}
                </span>
              </h4>
            ) : null}
            {priceDetails?.netPrice ? (
              <p className="text-[var(--davy-gray-color)] font-medium text-lg max-lg:text-sm">
                {t("/vehicleDetails.Net")}: &nbsp;
                <span className="text-lg">
                  {convertNumberFormat(priceDetails?.netPrice, currency)}
                </span>
              </p>
            ) : null}
            {vehicleDetails?.oldListPrice?.totalPrice ? (
              <p className="text-[var(--davy-gray-color)] font-medium text-lg max-lg:text-sm">
                {t("/vehicleDetails.RRP")}: &nbsp;
                <span className="text-lg">
                  {convertNumberFormat(
                    vehicleDetails?.oldListPrice?.totalPrice,
                    currency,
                  )}
                </span>
              </p>
            ) : null}
          </div>
        </li>
      ) : null}
    </ul>
  );
};
export default BuyingTabView;
